import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";

export function RenameFileDialog({ file, queryKey, onClose }) {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const [name, setName] = useState("");

  useEffect(() => {
    if (file) setName(file.filename);
  }, [file]);

  const renameMut = useMutation({
    mutationFn: async () => (await api.put(`/drive/files/${file.id}/rename`, { filename: name })).data,
    onSuccess: () => {
      toast.success(t("common.renamedToast"));
      onClose();
      qc.invalidateQueries({ queryKey });
    },
    onError: (e) => toast.error(fmtErr(e)),
  });

  return (
    <Dialog open={!!file} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="drive-rename-dialog">
        <DialogHeader><DialogTitle>{t("common.renameFile")}</DialogTitle></DialogHeader>
        <div className="space-y-1.5">
          <Label>{t("common.newName")}</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} data-testid="drive-rename-input" />
        </div>
        <DialogFooter>
          <Button onClick={() => renameMut.mutate()} disabled={!name.trim() || renameMut.isPending} data-testid="drive-rename-submit">{t("common.save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
